import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AccountService } from 'src/app/shared/services/account.service';

@Injectable({
  providedIn: 'root',
})
export class AppAccessControlService {
  constructor(
    private accountService: AccountService,
    private router: Router,
  ) {}

  private readonly allowedPages = ['/', '/login', '/logout', '/logout-callback', '/update', '/hard-cut-over-to-sp-app'];

  async checkCarerAccess(currentUrl: string): Promise<boolean> {
    const user = await this.accountService.account();
    if (user?.accountType === 'Carer') {
      const normalizedUrl = currentUrl.startsWith('/') ? currentUrl : `/${currentUrl}`;
      if (this.allowedPages.includes(normalizedUrl)) {
        return true;
      }
      this.router.navigate(['/hard-cut-over-to-sp-app']);
      return false;
    }
    return true;
  }
}
